import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import "./Section.scss";

const Section = ({
	className,
	children,
	header,
}) => (
	<div className={classnames(className, "messages-section")}>
		{header &&
			<div className="messages-section-header">
				{header}
			</div>
		}

		<div className="messages-section-content">
			{children}
		</div>
	</div>
);

Section.propTypes = {
	className: PropTypes.string,
	header: PropTypes.node,
	children: PropTypes.node,
};

Section.defaultProps = {
	className: "",
	header: null,
	children: "",
};

export default Section;



// WEBPACK FOOTER //
// ./src/apps/messages/components/Section.jsx